import{SUCCESS_DELETE_COUPONS_FROM_CART}from"../constants";/**
 * Creates the dispatched SUCCESS_DELETE_COUPONS_FROM_CART action object.
 * @returns {Object} The dispatched action object.
 */var successDeleteCouponsFromCart=function successDeleteCouponsFromCart(){return{type:SUCCESS_DELETE_COUPONS_FROM_CART};};export default successDeleteCouponsFromCart;